var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _sortBy from 'lodash/sortBy';
var removeDuplicates = function (objectsArray) {
    return __spreadArray([], Array.from(new Set(objectsArray.map(function (object) { return JSON.stringify(object); }))), true).map(function (string) { return JSON.parse(string); });
};
export var enumerateUniqueOptions = function (devices) {
    if (!devices) {
        return {
            color: [],
            condition: [],
            storage: []
        };
    }
    // Find storage options for device
    var storage = _sortBy(devices.map(function (phone) { return phone.storage; }).filter(function (x) { return x; }), ['unit', 'size']);
    // Find all the colors available for device
    var colors = devices.map(function (device) { return device.color; }).filter(function (x) { return x; });
    // Find all the conditions for device
    var condition = devices.map(function (device) { return device.condition; }).filter(function (x) { return x; });
    return {
        storage: removeDuplicates(storage),
        color: removeDuplicates(colors),
        condition: removeDuplicates(condition)
    };
};
var getUniqueDeviceOptions = function (devices, activeCondition, activeStorage) {
    var options = enumerateUniqueOptions(devices);
    // Find all the storage options for the active condition.
    var activeStorageIds = devices
        .map(function (device) { var _a, _b; return ((_a = device === null || device === void 0 ? void 0 : device.condition) === null || _a === void 0 ? void 0 : _a.id) === activeCondition && ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id); })
        .filter(function (x) { return x; });
    // Find all the colors for the active condition and active storage.
    var activeColorIds = devices
        .map(function (device) {
        var _a, _b, _c;
        return ((_a = device === null || device === void 0 ? void 0 : device.condition) === null || _a === void 0 ? void 0 : _a.id) === activeCondition &&
            ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id) === activeStorage &&
            ((_c = device === null || device === void 0 ? void 0 : device.color) === null || _c === void 0 ? void 0 : _c.id);
    })
        .filter(function (x) { return x; });
    return {
        conditionOptions: options.condition,
        storageOptions: options.storage.filter(function (item) { return activeStorageIds.includes(item.id); }),
        colorOptions: options.color.filter(function (item) { return activeColorIds.includes(item.id); })
    };
};
export default getUniqueDeviceOptions;
